module.exports = ".argo-table-list{margin:1em}.argo-table-list__row:hover{box-shadow:1px 2px 3px rgba(0,0,0,.1),0 0 0 1px rgba(31,189,208,.5)}"